
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MerchantChannel } from '@/enums/SmoothrPay';
import { BusinessLine, MerchantConfiguration, UpdateBusinessLineRequest } from '@/interfaces/models/SmoothrPay';

/**
 * The business lines Adyen knows about. Only an existing line (one with an
 * Adyen id) can be patched — before that it is still part of the configuration
 * document and changes with a re-run of the business-lines step.
 */
@Component
export default class BusinessLines extends Vue {
  @Prop({ type: Object, required: true }) public configuration!: MerchantConfiguration;
  @Prop({ type: Boolean, default: false }) public canManage!: boolean;
  @Prop({ type: Boolean, default: false }) public saving!: boolean;

  public dialogVisible: boolean = false;
  public editing: BusinessLine | null = null;
  public form: UpdateBusinessLineRequest = {};

  get channelItems() {
    return [
      { text: this.$t('smoothrPay.channels.ecom'), value: MerchantChannel.ECOM },
      { text: this.$t('smoothrPay.channels.pos'), value: MerchantChannel.POS },
    ];
  }

  get needsWebAddress(): boolean {
    const channels = this.form.salesChannels || [];
    return channels.indexOf(MerchantChannel.ECOM) > -1 && !this.form.webAddress;
  }

  public edit(line: BusinessLine) {
    this.editing = line;
    this.form = {
      industryCode: line.industryCode,
      salesChannels: (line.salesChannels || []).slice(),
      webAddress: line.webAddress,
    };
    this.dialogVisible = true;
  }

  public save() {
    if (!this.editing || !this.editing.id || this.needsWebAddress) {
      return;
    }
    const payload: UpdateBusinessLineRequest = {
      industryCode: this.form.industryCode,
      salesChannels: this.form.salesChannels,
    };
    // Omitted rather than '' — the service validates the URI when it is present.
    if (this.form.webAddress) {
      payload.webAddress = this.form.webAddress;
    }
    this.$emit('save', { businessLineId: this.editing.id, payload });
    this.dialogVisible = false;
  }
}
